import type { SupabaseClient } from "@supabase/supabase-js";

/**
 * Invoke a Supabase Edge Function with a fresh session and Authorization header.
 * Use this for any function that requires auth to avoid 401s from missing or stale tokens.
 */
export async function invokeAuthedFunction<T>(
  supabase: SupabaseClient,
  name: string,
  body: unknown
): Promise<T> {
  const {
    data: { session },
    error,
  } = await supabase.auth.getSession();

  if (error || !session?.access_token) {
    throw new Error(`Missing session for function ${name}`);
  }

  const { data, error: fnError } = await supabase.functions.invoke<T>(name, {
    body,
    headers: {
      Authorization: `Bearer ${session.access_token}`,
    },
  });

  if (fnError) throw fnError;
  return data;
}
